import {Component, Property} from '@wonderlandengine/api';

export class HideObjectOnClick extends Component {
    static TypeName = 'hide-object-on-click';

    static Properties = {
        target: Property.object(),
    };

    start() {
        const ct = this.object.getComponent('cursor-target');
        ct.addClickFunction(this.onClick.bind(this));
    }

    onClick() {
        if (!this.target) return;

        const mesh = this.target.getComponent('mesh');
        if (mesh) mesh.active = false;

        const col = this.target.getComponent('collision');
        if (col) col.active = false;
    }
}